import { NgModule } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { CommonModule  } from '@angular/common';

import {Ng2ScrollableDirective} from "./ng2-scrollable.directive";

export { Ng2ScrollableDirective };

@NgModule({
  imports: [ CommonModule, FormsModule ],
  declarations: [Ng2ScrollableDirective],
  exports: [ Ng2ScrollableDirective ]
})
export class Ng2ScrollableModule {}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/strip-loader/lib?strip[]=debug,strip[]=console.log!./src/ng2-scrollable.module.ts